import React from 'react';
import { useSettings } from '../context/SettingsContext';
import { formatDateTime, formatRelativeTime } from '../utils/dateTime';

const GymEventList = ({ events }) => {
  const { timezone } = useSettings();

  const renderEventDetails = (type, details) => {
    try {
      const detailsObj = typeof details === 'string' ? JSON.parse(details) : details;
      
      switch (type) {
        case 'team_change':
          return (
            <span>
              Team changed. {getTeamName(detailsObj.old_team)} → {getTeamName(detailsObj.new_team)}.
            </span>
          );
          
        case 'monster_added':
          return (
            <span>
              Pokemon #{detailsObj.monster_id} added to position {detailsObj.position}
              {detailsObj.cp > 0 ? ` with CP ${detailsObj.cp}` : ''}.
            </span>
          );
          
        case 'monsters_removed':
          return (
            <span>
              {detailsObj.slots_available - detailsObj.slots_available_before} monster(s) finally defeated. 
              New slots available: {detailsObj.slots_available}.
            </span>
          );
          
        case 'monster_attacked':
          return (
            <span>
              Gym attacked. Total CP {detailsObj.old_cp} → {detailsObj.new_cp} ({-Math.round((detailsObj.decrease / detailsObj.old_cp) * 100)}% / {-detailsObj.decrease} CP).
            </span>
          );
          
        case 'monster_fed':
          return (
            <span>
              Gym fed. Total CP {detailsObj.old_cp} → {detailsObj.new_cp} (+{Math.round((detailsObj.increase / detailsObj.old_cp) * 100)}% / +{detailsObj.increase} CP).
            </span>
          );
          
        default:
          return <span>{JSON.stringify(detailsObj)}</span>;
      }
    } catch (e) {
      console.error('Error parsing event details:', e);
      return <span>Error parsing event details</span>;
    }
  };

  const getTeamName = (teamId) => {
    switch (teamId) {
      case 0: return 'Empty';
      case 1: return 'Blue';
      case 2: return 'Red';
      case 3: return 'Yellow';
      default: return `Team ${teamId}`;
    }
  };

  const getEventName = (eventTag) => {
    switch (eventTag) {
      case 'team_change': return 'Team Changed';
      case 'monster_added': return 'Pokemon Added';
      case 'monsters_removed': return 'Pokemon Removed';
      case 'monster_attacked': return 'Pokemon Defeated';
      case 'monster_fed': return 'Pokemon Fed';
      default: return eventTag.replace(/_/g, ' ');
    }
  };

  return (
    <div className="gym-event-list">
      {events.length === 0 ? (
        <div className="no-events-message">
          <p>No events in the selected time span.</p>
        </div>
      ) : (
        <ul>
          {events.map((event) => (
            <li key={`${event.gym_id}_${event.timestamp}`} className={`event-item event-${event.type}`}>
              <div className="event-time">
                <span className="time-absolute">{formatDateTime(event.timestamp, timezone)}</span>
                <span className="event-type">{getEventName(event.type)}</span>
                <span className="time-relative">{formatRelativeTime(event.timestamp)}</span>
              </div>
              <div className="event-content">
                <div className="event-details">
                  {renderEventDetails(event.type, event.details)}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default GymEventList;